import React from 'react'

import '../css/skeleton.css'
import '../css/normalize.css'
import '../css/components.css'

function Footer() {
    return (
        <div className="Footer container">
            <p>Made with <span class="heart">❤️</span> by <a href={"https://twitter.com/ssmaciel"}>Samuka Maciel</a></p>
        </div>
    )
}

export default Footer
